<nav class="bottom-nav" role="navigation" aria-label="Navegação principal" data-cy="bottom-nav">
  @for (item of menuItems(); track item.id) {
    <button
      type="button"
      class="bottom-nav__item"
      [class.bottom-nav__item--active]="isActive(item)"
      [class.bottom-nav__item--disabled]="item.disabled"
      [attr.aria-current]="isActive(item) ? 'page' : null"
      [attr.data-cy]="'bottom-nav-' + item.id"
      (click)="onItemClick(item)">
      <span class="bottom-nav__icon-wrapper">
        <lkt-icon class="bottom-nav__icon" [name]="iconName(item.icon)" [size]="22" />
      </span>
      <span class="bottom-nav__label">{{ item.label }}</span>
    </button>
  }

  @if (showNotifications()) {
    <button
      type="button"
      class="bottom-nav__item bottom-nav__item--bell"
      (click)="onNotificationsClick($event)"
      [attr.aria-label]="notificationsState.bellAriaLabel()"
      aria-haspopup="dialog"
      [attr.aria-expanded]="notificationsState.panelOpen()"
      data-cy="bottom-nav-notifications">
      <span class="bottom-nav__icon-wrapper">
        <lkt-icon class="bottom-nav__icon" name="bell" [size]="22" />
        @if (notificationsState.badgeLabel()) {
          <!-- aria-hidden: a contagem já está no aria-label do botão. -->
          <span class="bottom-nav__badge" aria-hidden="true">
            {{ notificationsState.badgeLabel() }}
          </span>
        }
      </span>
      <!--
        DEV-872 (correção pedida pelo dono): o rótulo curto "Avisos" foi invenção do plano — o
        design nunca usa essa palavra como rótulo de interface, só em prosa. `bottom-nav__label`
        já trunca com reticências (`text-overflow: ellipsis`) e esta mesma barra já embarca
        "Atribuições" (11 caracteres) sem problema; "Notificações" (12) segue o mesmo precedente.
        Nome acessível volta a vir de `state.bellAriaLabel()` só, o que também fecha as três cópias
        da lógica de plural em uma: WCAG 2.5.3 continua satisfeito porque "Notificações" (visível)
        é prefixo de "Notificações" / "Notificações, N não lidas" (acessível).
      -->
      <span class="bottom-nav__label">Notificações</span>
    </button>
  }

  <app-shared-user-bottom-sheet [appVersion]="appVersion()" label="Você" dataCy="bottom-nav-user" />
</nav>
